import { getDeviceErrorData } from '../../../../api/eastCoastDataApi/device/DeviceErrorApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  deviceErrorList: [],
  deviceDailyErrorList:[],
}

const getters = {

}

const actions = {
  async getDeviceErrorData({ commit },  condition) {
    const result = await getDeviceErrorData(condition);

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('deviceErrorList', result.data)
      commit('deviceDailyErrorList', result.data)

    }

  },
}

const mutations = {
  deviceErrorList(state, data) {
    if (Utils.isEmptyObject(data)) {
      state.deviceErrorList = []
      return
    }
    state.deviceErrorList = data

  },

  deviceDailyErrorList(state, data) {
    //only daily check error
    if (Utils.isEmptyObject(data)) {
      state.deviceErrorList = []
      return
    }

    const a =  data.filter((item) => {
      return item.errorCode === CONST.DEVICE_ERROR_CODE.DAILY_CHECK_ERROR;
    })

    state.deviceDailyErrorList = a;

  },


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}